export default __webpack_public_path__ + "assets/b97db53102420135cd3c2a4bded57c0d.png";